import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { LittleSubHeadline } from "../typography";
import { AnimatePresence, motion } from "framer-motion";

type RadioButtonProps = {
  id: string;
  name: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: () => void;
};

export const RadioButton: React.FC<React.PropsWithChildren<RadioButtonProps>> = ({
  id,
  name,
  label,
  checked,
  disabled,
  onChange,
  children
}) => {
  return (
    <Wrapper>

      {/* <StyledLabel htmlFor={id} $checked={checked} $disabled={disabled}>
        <span className="radio" />
        {label}
        </StyledLabel> */}
      <HiddenRadio
        type="radio"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <StyledLabel htmlFor={id} $checked={checked} $disabled={disabled}>
        <span className="radio" />
        {label}
      </StyledLabel>
      <AnimatePresence >
        {checked && <Content initial={{ opacity: 0, height: 0, y: -6 }}
          animate={{ opacity: 1, height: "auto", y: 0 }}
          exit={{ opacity: 0, height: 0, y: -6 }}
          transition={{ duration: 0.25, ease: "easeInOut" }} className="d-flex flex-column gap-1">
          {children}
        </Content>
        }
      </AnimatePresence>

    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding-left: 4px;
`;

const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 26px;
  font-size: 0.9rem;
  color: ${COLORS["bg-text-color"]};
  line-height: 1.4;
  overflow: hidden;
`;

const StyledLabel = styled.label<{ $disabled?: boolean; $checked?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
   ${LittleSubHeadline.componentStyle.rules.join("")}
    transition: font-weight 0.15s ease;
 font-weight: ${({ $checked }) =>
    !$checked ? 450 : 600} !important;
  color: ${COLORS.secondary1};

  .radio {
    width: 18px;
    height: 18px;
    padding: 2px;
    border: 2px solid
      ${({ $checked }) =>
    !$checked ? COLORS["bg-text-color"] : COLORS.blue};
    border-radius: 50%;
    display: grid;
    place-items: center;
    transition: border-color 0.15s ease;
  }

  .radio::after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${({ $checked }) =>
    !$checked ? COLORS["bg-text-color"] : COLORS.blue};
    transform: scale(0);
    transition: transform 0.15s ease;
  }

  ${HiddenRadio}:checked + & .radio::after {
    transform: scale(1);
  }

  /* ${HiddenRadio}:focus + & .radio {
    outline: 2px solid ${COLORS["bg-text-color"]};
    outline-offset: 2px;
  } */

  ${HiddenRadio}:hover + & .radio {
    /* border-color: ${COLORS["light-blue"]}; */
    //transform: scale(1.1);

  }

  ${({ $disabled }) =>
    $disabled &&
    `
    .radio::after {
      background-color: ${COLORS.gray};
    }
  `}
`;
